<template>
    <div class="pre-reg__search">
        <dropdown
            heading="Select a Specialty"
            category="specialties"
            :options="specialties"
            @change="getServices"
        />
        <dropdown
            heading="Select a Service"
            category="services"
            :options="services"
            :disabled="disabled"
            @change="getForms"
        />
        <forms
            v-if="selectedService"
            :heading="selectedService"
            :forms="forms"
        />
    </div>
</template>

<script>
import $location from 'wee-location';
import $fetch from 'wee-fetch';
import dropdown from '../dropdown/index.vue';
import forms from '../forms/index.vue';

const basePath = $location.uri().origin;

export default {
    components: { dropdown, forms },
    data: () => {
        return {
            specialties: null,
            services: null,
            selectedService: null,
            forms: null,
            disabled: true,
        }
    },
    created() {
        $fetch.get(`${basePath}/specialties.json`)
            .then(({ data }) => {
                this.specialties = data.data;
            }).catch(error => console.error(error));
    },
    methods: {
        getServices(specialty) {
            $fetch.get(`${basePath}/services/${specialty.id}.json`)
                .then(({ data }) => {
                    this.services = data.data;
                    this.disabled = false;
                    this.selectedService = null;
                }).catch(error => console.error(error));
        },
        getForms(service) {
            $fetch.get(`${basePath}/forms/${service.id}.json`)
                .then(({ data }) => {
                    this.selectedService = null;
                    this.selectedService = service.title;
                    this.forms = data.data;
                }).catch(error => console.log(error));
        }
    }
}
</script>
